// S18B-2 — e-Map API hook (OSWC GAP-2).
import { useQuery } from "@tanstack/react-query";

import { api } from "./client";

export type HealthStatus = "green" | "amber" | "red" | "grey";

export interface EMapEntity {
  id: string;
  name: string;
  lat: number;
  lng: number;
  health_status: HealthStatus;
  camera_count: number;
  cameras_offline: number;
  active_alarm_count: number;
}

export interface EMapResponse {
  entities: EMapEntity[];
  missing_coordinates: number;
}

export function useEmapEntities() {
  return useQuery({
    queryKey: ["emap", "entities"],
    queryFn: async () => {
      const { data } = await api.get<EMapResponse>("/api/v1/emap/entities");
      return data;
    },
    refetchInterval: 30_000,
  });
}
